<template>
  <Dropdown
    class-name="session-report"
    :title="t('session.report.title')"
    :default-open="true"
    :is-loaded="!isPendingRef"
  >
    <p
      v-if="sessionRef?.report && sessionRef?.report.createdAt < sessionRef.report.updatedAt"
      class="session-report__report"
    >
      {{ sessionRef.report.comment }} <br />
      <span class="session-report__report__updated-at"
        >{{ t('session.report.modified') }}
        {{ dayjsClient(sessionRef.report.updatedAt).format('DD/MM/YYYY - HH:mm') }}</span
      >
    </p>
    <p
      v-else-if="sessionRef?.report && sessionRef?.report.createdAt == sessionRef.report.updatedAt"
      class="session-report__report"
    >
      "{{ sessionRef.report.comment }}"
    </p>
    <EmptyContent v-else :text="t('session.report.empty')" />
    <div v-if="sessionRef?.report" class="c-btns-container c-btn-center">
      <CustomButton
        v-if="groupRolesRef?.includes(RoleEnumTypeV2.MENTOR)"
        usage="button"
        color="primary"
        :text="t('session.reportModal.modifyReport.report')"
        @emit:click="onClickModifyRating"
      >
        <template #icon>
          <EditIcon color="white" />
        </template>
      </CustomButton>
    </div>
  </Dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RoleEnumTypeV2 } from '@/features/auth/types'
import useSession from '@/features/sessions/hooks/use-session.hook'
import CustomButton from '@/features/ui/components/button/custom-button.vue'
import Dropdown from '@/features/ui/components/dropdown/dropdown.vue'
import EmptyContent from '@/features/ui/components/empty-content/empty-content.vue'
import EditIcon from '@/features/ui/components/icons/edit-icon.vue'
import { selectGetSessionDetailsModal } from '@/features/ui/store/modal/modal.selectors'
import type { ReviewSessionModalType } from '@/features/ui/store/modal/modal.store'
import modalsStore from '@/features/ui/store/modal/modal.store'
import useGroupRoles from '@/features/users/hooks/use-group-roles.hook'
import dayjsClient from '@/lib/dayjs'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()

const sessionDetailsModalRef = selectGetSessionDetailsModal(modalsStore)

const sessionIdRef = computed(() => sessionDetailsModalRef.value.attachedData.sessionId ?? null)
const { sessionRef, isPendingRef } = useSession(sessionIdRef)

const groupIdRef = computed(() => sessionRef.value?.mentoringGroupId ?? null)
const { groupRolesRef } = useGroupRoles({ groupIdRef })
const onClickModifyRating = () => {
  modalsStore.toggleModal('review-session', true)
  modalsStore.toggleModal('session-details', false)

  modalsStore.setModalStep<ReviewSessionModalType>('review-session', 'report')
  modalsStore.updateModalAttachedData<ReviewSessionModalType>('review-session', {
    sessionId: sessionIdRef.value!,
  })
}
</script>

<style lang="scss">
@import './session-report.scss';
</style>
